<template>
  <div @load="loadImage">
      <div class="gameplay_title_container">
        <div class="gameplay_title">
          {{ gameInfo.question }}
        </div>
      </div>
      <div class="gameplay_game_box_list gameplay_tap_box" >
        <div class="gameplay_tap_container" >
          <div v-for="(row, rowIndex) in numOfRow" :key="row" class="gameplay_tap_row">
            <button v-for="(answer, index) in numOfCols" :key="index"
                  @click="sendAnswer(twoDimensionalTable[rowIndex][index], rowIndex, index + 1)"
                  class="tap_btn curs_def" :ref="index + 1"
                  :style="!buttonPushed ? 'cursor:pointer' : 'pointer-events:none'"
                  :disabled="buttonPushed" >
            </button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'memoryPattern',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
      buttonPushed: true,
      twoDimensionalTable: [],
      numOfRow: 0,
      numOfCols: 3,
    };
  },
  created() {
    this.initGameData();
  },
  mounted() {
    this.greenTheSquares();
    this.$nextTick(() => { this.loadImage(); });
  },
  methods: {
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      console.log(this.gameInfo.list);
      this.tries = this.gameInfo.tries;
      this.createMatrix();
    },
    createMatrix() {
      let index = 0;
      this.numOfRow = this.gameInfo.list.length === 12 ? 4 : 3;
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill());
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.twoDimensionalTable[i][j] = this.gameInfo.list[index];
          index += 1;
        }
      }
    },
    greenTheSquares() {
      let indexX = 1;
      let indexY = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          if (this.twoDimensionalTable[i][j] === true) {
            this.$refs[indexX][indexY].classList.add('change_btn_color');
          }
          indexX += 1;
        }
        indexX = 1;
        indexY += 1;
      }
      setTimeout(() => {
        this.timeToHideGreenSquares();
      }, this.gameInfo.timer);
    },
    timeToHideGreenSquares() {
      let indexX = 1;
      let indexY = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          if (this.$refs[indexX][indexY].classList.contains('change_btn_color')) {
            this.$refs[indexX][indexY].classList.remove('change_btn_color');
          }
          indexX += 1;
        }
        indexX = 1;
        indexY += 1;
      }
      this.buttonPushed = false;
    },
    disableDiv(rowIndex, colIndex) {
      return this.buttonPushed || this.$refs[colIndex][rowIndex].classList.contains('change_btn_color');
    },
    playNextGame(isCorrectAnswer) {
      console.log('wait 1,5 secs for response and go to next game');
      setTimeout(() => {
        console.log('Go to next game');
        this.normalTransition = true;
        this.storeBrainiacGameData(isCorrectAnswer);
        this.buttonPushed = false;
      }, 1500);
    },
    sendAnswer(value, rowIndex, colIndex) {
      if (this.buttonPushed || this.$refs[colIndex][rowIndex].classList.contains('change_btn_color')) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        console.log('BOOLEAN VALUE', value);
        let booleanToNumber;
        if (value === true) {
          booleanToNumber = 0;
        } else {
          booleanToNumber = 1;
        }
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${booleanToNumber}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.buttonPushed = false;
              this.$refs[colIndex][rowIndex].classList.add('worng_tap');
              setTimeout(() => {
                this.$refs[colIndex][rowIndex].classList.remove('worng_tap');
              }, 2000);
            } else if (responseData.status === 'CORRECT_ANSWER') {
              this.buttonPushed = false;
              this.$refs[colIndex][rowIndex].classList.add('change_btn_color');
            } else if (responseData.status === 'USER_FOUND_THE_PATTERN') {
              this.$refs[colIndex][rowIndex].classList.add('change_btn_color');
              this.playNextGame(true);
            } else if (responseData.status === 'MAX_ATTEMPTS_REACHED') {
              this.$refs[colIndex][rowIndex].classList.add('worng_tap');
              setTimeout(() => {
                this.$refs[colIndex][rowIndex].classList.remove('worng_tap');
              }, 2000);
              this.playNextGame(false);
            } else {
              // something bad happened
            }
          }
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'timeRoundIntro',
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/game/memory/MemoryPattern.vue